module.exports = __webpack_public_path__ + "static/media/reset.f4db9d84.svg";